import { render } from "./BaseFormModal.vue?vue&type=template&id=72f33e2e"
import script from "./BaseFormModal.vue?vue&type=script&lang=js"
export * from "./BaseFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__